import axios from 'axios';

const base_url = process.env.REACT_APP_VR_BASE_URL;
const xapikey = process.env.REACT_APP_VR_XAPIKEY;

const generateCorrelationId = () => {
    const length = 16;
    const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const result = Array.from({ length }, () => charset.charAt(Math.floor(Math.random() * charset.length))).join('');
    return result
  }

export const axiosClient = axios.create({
    baseURL: base_url,
    headers: {
        'x-api-key': xapikey, 
        'Content-Type': 'application/json'
    }
});

axiosClient.interceptors.request.use(
    (config) => {
        const correlationId = generateCorrelationId(); 
        config.headers.correlation_id = correlationId;
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export const put_service = async (url, data, headers = {}) => {
        try {
            const response = await axiosClient.put(
                url, data, { headers }
            );
            return successResponse(response);
        } catch (error) {
            return errorResponse(error);
        }
};


const errorResponse = (error) => {
    const result = {
        success: false,
        data: null,
        code: 0,
    };
    if (error?.response?.status === 401) {
        console.log(error?.response.data.message)
    } else if (error?.response?.status === 500) {
        alert(error?.response?.data.error);
    } else if (error?.response?.status === 400) {
        if (error?.response?.data) {
            console.log(error?.response?.data.error);
        } else {

        }
    } else if (error?.response?.status === 403) {
        console.log(error?.response?.data.error);
    }
    else if (error?.response?.status === 404) {
        console.log(error?.response.data.message)
    } else {
        alert(error?.response.data.error)
    }
    if (error.response) {
        result.data = error.response.data;
        result.code = error.response.status;
        return result;
    }
    if (error.message) {
        result.data = error.message;
        return result;
    }
};
const successResponse = (response) => {
    const result = {
        success: true,
        data: "null",
        code: 0,
    };
    if (response.data) {
        result.data = response.data;
        result.code = response.status;
        return result;
    } else {
        result.code = response.status;
        return result;
    }
};